import { forwardRef, useId } from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className, ...rest }, ref) => {
    const generatedId = useId();
    const inputId = rest.id ?? generatedId;

    return (
      <div className="space-y-2">
        {label && (
          <label htmlFor={inputId} className="block text-sm font-medium text-zinc-300">
            {label}
            {rest.required && <span className="text-red-400">*</span>}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          {...rest}
          className={`w-full rounded-xl border bg-input px-4 py-3 transition-all
            ${
              error
                ? 'border-red-500/50 focus:ring-red-500/20'
                : 'border-border focus:border-blue-500/50 focus:ring-blue-500/20'
            }
            text-white placeholder:text-muted focus:outline-none focus:ring-2
            disabled:cursor-not-allowed disabled:opacity-50
            ${className || ''}`}
        />
        {error && <p className="text-sm text-red-400">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
